import { sfAnd, sfEqual, sfGt } from 'spring-filter-query-builder';
import { escapeSfqbString } from '../sfqb';
import { sfLike } from './sfqb';

const SYSTEM_DEFAULT_FILTER = sfAnd([sfGt('bLevel', 1), sfEqual('visible', 'true')]);

export const makeSystemFilter = (searchParam: string): string => {
    const terms = searchParam.trim().split(/\s+/);
    const conditions = terms.map((term) => sfLike('fullname', `*${escapeSfqbString(term, true)}*`, true));
    const finalFilter = sfAnd(conditions);
    return sfAnd([SYSTEM_DEFAULT_FILTER, finalFilter]).toString();
};
